// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var TradingMode;
(function (TradingMode) {
    TradingMode[TradingMode["FullyClosed"] = 0] = "FullyClosed";
    TradingMode[TradingMode["FullyOpen"] = 1] = "FullyOpen";
    TradingMode[TradingMode["TradingHalt"] = 2] = "TradingHalt";
    TradingMode[TradingMode["LiquidationOnly"] = 3] = "LiquidationOnly";
    TradingMode[TradingMode["CAMaintenance"] = 4] = "CAMaintenance";
})(TradingMode || (TradingMode = {}));
